import { apply, load, setAlias } from '../engine'

apply()

export { apply, load, setAlias }
